module.exports = __webpack_public_path__ + "static/media/NodeJS_example.3c369529.zip";